import { ApiCaller, setCsrfToken } from 'apis/ApiCaller';

export type MeResponse = {
    currentUser?: {
        fullName: string;
        userId: string;
        userName: string;
        userProfileId: number;
        userType: string;
    } | null;
    loginConfig: {
        requireCaptcha: boolean;
        turnstileSiteKey: string;
    };
};

export type AntiForgeryTokenResponse = {
    token: string;
};

export type ValidateResetTokenResponse = {
    displayName?: string;
};

export type ResetPasswordResponse = Record<string, never>;

export type WelcomeSetPasswordResponse = {
    redirectUrl?: string;
};

export class AuthPublicApi {

    private static apiCaller = new ApiCaller('AuthPublic');

    public static Me(): Promise<MeResponse> {

        return this.apiCaller.GET<MeResponse>('Me');

    }

    public static async GetAntiForgeryToken(): Promise<AntiForgeryTokenResponse> {

        const result = await this.apiCaller.GET<AntiForgeryTokenResponse>('GetAntiForgeryToken');
        setCsrfToken(result?.token);
        return result;

    }

    public static ValidateResetToken(userId: string, token: string): Promise<ValidateResetTokenResponse> {

        return this.apiCaller.GET<ValidateResetTokenResponse>('ValidateResetToken', { l: token, q: userId });

    }

    public static ResetPassword(userId: string, token: string, newPassword: string, turnstileToken: string): Promise<ResetPasswordResponse> {

        return this.apiCaller.POST<ResetPasswordResponse>('ResetPassword', { l: token, newPassword, q: userId, turnstileToken });

    }

    public static WelcomeSetPassword(userId: string, token: string, newPassword: string): Promise<WelcomeSetPasswordResponse> {

        return this.apiCaller.POST<WelcomeSetPasswordResponse>('WelcomeSetPassword', { l: token, newPassword, q: userId });

    }

}
